export const GET_AUDIO_COMMENTS = '@@MINDSETS/GET_AUDIO_COMMENTS';
export const GET_AUDIO_COMMENTS_REQUEST =
  '@@MINDSETS/GET_AUDIO_COMMENTS_REQUEST';
export const GET_AUDIO_COMMENTS_SUCCESS =
  '@@MINDSETS/GET_AUDIO_COMMENTS_SUCCESS';
export const GET_AUDIO_COMMENTS_FAILURE =
  '@@MINDSETS/GET_AUDIO_COMMENTS_FAILURE';

export const FETCH_COMMENT_REPLIES = '@@MINDSETS/FETCH_COMMENT_REPLIES';
export const FETCH_COMMENT_REPLIES_REQUEST =
  '@@MINDSETS/FETCH_COMMENT_REPLIES_REQUEST';
export const FETCH_COMMENT_REPLIES_SUCCESS =
  '@@MINDSETS/FETCH_COMMENT_REPLIES_SUCCESS';
export const FETCH_COMMENT_REPLIES_FAILURE =
  '@@MINDSETS/FETCH_COMMENT_REPLIES_FAILURE';

export const ADD_COMMENT_REPLY = '@@MINDSETS/ADD_COMMENT_REPLY';
export const ADD_COMMENT_REPLY_REQUEST = '@@MINDSETS/ADD_COMMENT_REPLY_REQUEST';
export const ADD_COMMENT_REPLY_SUCCESS = '@@MINDSETS/ADD_COMMENT_REPLY_SUCCESS';
export const ADD_COMMENT_REPLY_FAILURE = '@@MINDSETS/ADD_COMMENT_REPLY_FAILURE';

export const ADD_COMMENT = '@@MINDSETS/ADD_COMMENT';
export const ADD_COMMENT_REQUEST = '@@MINDSETS/ADD_COMMENT_REQUEST';
export const ADD_COMMENT_SUCCESS = '@@MINDSETS/ADD_COMMENT_SUCCESS';
export const ADD_COMMENT_FAILURE = '@@MINDSETS/ADD_COMMENT_FAILURE';

export const LIKE_COMMENT = '@@MINDSETS/LIKE_COMMENT';
export const LIKE_COMMENT_REQUEST = '@@MINDSETS/LIKE_COMMENT_REQUEST';
export const LIKE_COMMENT_SUCCESS = '@@MINDSETS/LIKE_COMMENT_SUCCESS';
export const LIKE_COMMENT_FAILURE = '@@MINDSETS/LIKE_COMMENT_FAILURE';

export const UNLIKE_COMMENT = '@@MINDSETS/UNLIKE_COMMENT';
export const UNLIKE_COMMENT_REQUEST = '@@MINDSETS/UNLIKE_COMMENT_REQUEST';
export const UNLIKE_COMMENT_SUCCESS = '@@MINDSETS/UNLIKE_COMMENT_SUCCESS';
export const UNLIKE_COMMENT_FAILURE = '@@MINDSETS/UNLIKE_COMMENT_FAILURE';

export const GET_COMMENT_DETAILS = '@@MINDSETS/GET_COMMENT_DETAILS';
export const GET_COMMENT_DETAILS_REQUEST =
  '@@MINDSETS/GET_COMMENT_DETAILS_REQUEST';
export const GET_COMMENT_DETAILS_SUCCESS =
  '@@MINDSETS/GET_COMMENT_DETAILS_SUCCESS';
export const GET_COMMENT_DETAILS_FAILURE =
  '@@MINDSETS/GET_COMMENT_DETAILS_FAILURE';
export const RESET_COMMENT = '@@MINDSETS/RESET_COMMENT';
